import { useEffect, useState } from "react";

export type ViewPortState = {
  readonly height?: number;
  readonly offsetLeft?: number;
  readonly offsetTop?: number;
  readonly pageLeft?: number;
  readonly pageTop?: number;
  readonly scale?: number;
  readonly width?: number;
};
export function useVisualViewport(): ViewPortState {
  const [viewPort, setViewPort] = useState<ViewPortState>({});

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) {
      return;
    }

    const update = () => {
      setViewPort({
        height: vv.height,
        offsetLeft: vv.offsetLeft,
        offsetTop: vv.offsetTop,
        pageLeft: vv.pageLeft,
        pageTop: vv.pageTop,
        scale: vv.scale,
        width: vv.width,
      });
    };

    update();
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    globalThis.addEventListener("orientationchange", update);

    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
      globalThis.removeEventListener("orientationchange", update);
    };
  }, []);

  return viewPort;
}
